<template>
    <div class="eventWaiverCreate">
        <v-stepper v-model="step" non-linear>
          <v-stepper-header>
            <v-stepper-step
              :complete="step > 1"
              step="1" :color="`${buttonColor}`"
            >{{ $t("eventWaiver.title_step_1") }}</v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step
              v-if="bandStep2"
              :complete="step > 2"
              step="2" :color="`${buttonColor}`"
            >{{ $t("eventWaiver.title_step_2") }}</v-stepper-step>
            <v-divider v-if="bandStep2"></v-divider>
            <v-stepper-step
              :complete="step > stepRoles"
              :step="stepRoles" :color="`${buttonColor}`"
            >{{ $t("eventWaiver.title_step_3") }}</v-stepper-step>
            <v-divider v-if="bandStep4"></v-divider>
            <v-stepper-step
              v-if="bandStep4"
              :complete="step > stepSignatory"
              :step="stepSignatory" :color="`${buttonColor}`"
            >{{ $t("eventWaiver.title_step_4") }}</v-stepper-step>
            <v-divider v-if="bandStep5"></v-divider>
            <v-stepper-step
              v-if="bandStep5"
              :complete="step > stepWaiver"
              :step="stepWaiver" :color="`${buttonColor}`"
            >{{ $t("eventWaiver.title_step_5") }}</v-stepper-step>
          </v-stepper-header>
          
          <v-stepper-items class="st_items">
            <v-stepper-content step="1" class="pa-sm-6 px-0">
                <Step1
                  ref="step1goStep2" 
                  @backStep="backStep"
                  @nextStep="nextStep"
                  @showSnackBar="showSnackBar"
                  @changePeoplesList="changePeoplesList"
                  @loadEvent="loadEvent"
                  :userSession="userStore"
                  :bandStep2="bandStep2"
                  :participantsPrevius="participantsREL"
                />
            </v-stepper-content>
            <v-stepper-content v-if="bandStep2" step="2" class="pa-sm-6 px-0">
                <Step2 
                  @backStep="step--"
                  @nextStep="goStep3"
                  @showSnackBar="showSnackBar"
                  @changeEventsList="changeEventsList"
                  :peoplesSelected="peopleSelected"
                />
            </v-stepper-content>
            <v-stepper-content :step="stepRoles" class="pa-sm-6 px-0">
                <Step3 
                  ref="step3goStep4"
                  :peoplesSelected="peopleSelected"
                  :eventsSelected="eventsSelected"
                  @backStep="step--"
                  @nextStep="goStep4"
                  @removeEvent="removeEvent"
                  @showSnackBar="showSnackBar"
                  @changePeoplesEventsList="changePeoplesEventsList"
                />
            </v-stepper-content>
            <v-stepper-content :step="stepSignatory" v-if="bandStep4" class="pa-sm-6 px-0">
                <Step4 
                  @backStep="step--"
                  @nextStep="nextStep"
                  @showSnackBar="showSnackBar"
                  :waivers="waivers"
                  :bandStep5="bandStep5"
                  :currentIp="currentIp"
                  @submitWaiver="submitWaiver"
                />
            </v-stepper-content>
            <v-stepper-content :step="stepWaiver" v-if="bandStep5" class="pa-sm-6 pa-0">
              <Step5 
                  ref="stepWaiver5"
                  @backStep="step--"
                  @nextStep="submitWaiver"
                  @showSnackBar="showSnackBar"
                  :currentIp="currentIp"
                  :eventsPeoplesList="eventsPeoplesList"
                  @changePeoplesEventsList="changePeoplesEventsList"
                  :waivers="waivers"
                  :listRegisters="listRegisters"
                  :peoplesSelected="peopleSelected"
                />
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
        <Snack :snack="snackbar" :snackMsg="msg_snackbar" :snackCol="color_snackbar"/>
    </div>
</template>

<script>
import { 
    VStepper, VStepperHeader, VStepperContent, VStepperItems, VStepperStep, VDivider
} from 'vuetify/lib';
import Snack from "@/components/notifications/Snack";
import Step1 from "@/components/waiver/Step1";
import Step2 from "@/components/waiver/Step2";
import Step3 from "@/components/waiver/Step3";
import Step4 from "@/components/waiver/Step4";
import Step5 from "@/components/waiver/Step5";
import LocalStorageService from "@/services/LocalStorageService";
import EventWaiverService from "@/services/EventWaiverService";
import RelationshipService from "@/services/RelationshipService";
import { mapState } from "vuex";
         
export default {
    components: {
        Step1, Snack, Step2, Step3, Step4, Step5, 
        VStepper, VStepperHeader, VStepperContent, VStepperItems, VStepperStep, VDivider
    },
    data() {
        return {
            step: 1,
            buttonColor: "#000",
            snackbar: false,
            msg_snackbar: "",
            color_snackbar: "",
            peopleSelected: [],
            eventsSelected: [],
            eventsPeoplesList: [],
            waivers: [],
            currentIp: "",
            listRegisters: [],
            nameComponentBack: 'EventWaiver',
            participantsREL: [], 
            listRegistersForStep5: []
        }
    },
    computed: {
      bandStep4() { return false; }, 
      bandStep5() { return true; },
      bandStep2() {
        return !this.$route.query.eventId;
      },
      stepRoles() {
        return this.bandStep2 ? 3 : 2;
      },
      stepSignatory() {
        return this.bandStep2 ? 4 : 3;
      },
      stepWaiver() {
        if((!this.bandStep2 && this.bandStep4) || (this.bandStep2 && !this.bandStep4)) return 4;
        if(!this.bandStep2 && !this.bandStep4) return 3;
        if(this.bandStep2 && this.bandStep4) return 5;
        return this.bandStep2 ? 5 : 4;
      },
      ...mapState({
          userStore: (state) => state.session.user
      })
    },
    created() {
        this.buttonColor = this.$store.getters.env.get('VUE_APP_BUTTON_COLOR');
    },
    mounted() {
      this.getIP();
      let nameComponentBack = LocalStorageService.getItem("link_back_event_waiver");
      nameComponentBack = nameComponentBack ? nameComponentBack : 'EventWaiver';
      this.nameComponentBack = nameComponentBack;
      if(this.nameComponentBack == 'RegisterEventLegacy') {
        let registrationObj = LocalStorageService.getItem("registration_legacy");
        let stepType = LocalStorageService.getItem("typeStep");
        if(registrationObj.eventSel && registrationObj.eventSel.isSpectatorRegistration && stepType == 'Spectator') {
          this.participantsREL = registrationObj.spectators;
        } else {
          this.participantsREL = registrationObj.participants;
        }
      }
    },
    methods: {
      getIP() {
          fetch(`${this.$store.getters.env.get('VUE_APP_ROOT')}/laravel/public/api/v1/users/current/currentIp`)
          .then(x => x.json())
          .then(({ message }) => {
              this.currentIp = message;
          });
      },
      nextStep() {
        this.step++;
      },
      backStep() {
        this.$router.push({ name: this.nameComponentBack });
      },
      showSnackBar({ msg, color }){
        this.snackbar = true;
        this.msg_snackbar = msg;
        this.color_snackbar = color;
        setTimeout(() => this.snackbar = false, 3000);
      },
      changePeoplesList(list) {
          this.peopleSelected = list.map((el) => {
            el.userRoleCode 
            return {
              ...el,
              userRoleCode: el.userRoleCode.split(',') 
            };
          });
      },
      changeEventsList(list) {
          this.eventsSelected = list;
      },
      changePeoplesEventsList(list) {
          this.eventsPeoplesList = list;
      },
      removeEvent(event) {
          this.eventsSelected = this.eventsSelected.filter((el) => el.eventId != event.eventId);
      },
      async goStep3() {
        let _adultAge = this.eventsSelected[0].adultAge;
        // Get logged in user data from Vuex store
        const userStore = this.$store.getters.user;
        let _userAge = this.getAge(userStore.birthday);
        if(_userAge < _adultAge) {
          this.showSnackBar({ msg: this.$t("eventWaiver.error_adult_age", { adultAge: _adultAge }), color: "error"});
          return;
        }

        let roles = [];
        await RelationshipService.getUserRoles().then(response =>{
            if(response.data.success == 1){
                roles = response.data.message.filter(x => {
                    return x.userRoleCode === 'Participant' || x.userRoleCode === 'Spectator';
                }).map((x) => {
                    return x.id
                });
            }
        });
        await EventWaiverService.getRelationshipList({
          rolesId: roles, 
          eventsId: this.eventsSelected.map((el) => el.eventId), 
          withUserLogin: true,
          authorizedUser: true
        }).then(response => {
            if(response.data.success == 1){
              let band = false;
              this.peopleSelected.forEach((item, i) => {
                response.data.message.forEach((item1) => {
                  if(item.userId == item1.userId) {
                    let disabledWaiver = false; let bandWaiver = false;
                    let age = this.getAge(item1.birthday);
                    let ageTarget = age >= 18 ? 'Adult' : 'Minor';
                    if(item1.eventWaiver && Array.isArray(item1.eventWaiver)) {
                      item1.eventWaiver.forEach((el1) => {
                          if(el1.data && el1.data.ageTarget == ageTarget && el1.data.waiverType) {
                              bandWaiver = true;
                          }
                      });
                    } else {
                        bandWaiver = true;
                    }
                    disabledWaiver = !bandWaiver;
                    this.peopleSelected[i].disabledWaiver = disabledWaiver;
                    this.peopleSelected[i].eventWaiverArray = item1.eventWaiverArray;
                    if(!band) {
                      this.eventsSelected.forEach((item2) => {
                      if(!(item1.eventWaiverArray && Array.isArray(item1.eventWaiverArray[item2.eventId]) && item1.eventWaiverArray[item2.eventId].length > 0)) {
                        band = true;
                        this.showSnackBar({ msg: this.$t("eventWaiver.invalid_waiver"), color: "warning"});
                      }
                    });
                    }
                  }
                });
              });
            }
        });
        this.nextStep();
      },
      goStep4() {
        const eventsId = this.eventsPeoplesList.map((el) => {
          return {
            id: el.eventId,
            usersId: el.peopleItems.map((el1) => {
              let roles = [];
              if(el1.participant) roles.push("Participant");
              if(el1.spectator) roles.push("Spectator");
              return {
                id: el1.userId,
                roles
              }
            })          
          }
        });

        EventWaiverService.generateWaiverForSpectator({ eventsId, listRegisters: this.listRegisters }).then((resp) => {
          if(resp.data.success) {
            if(this.bandStep4 || this.bandStep5) {
              this.waivers = [];
              resp.data.message.forEach((wItem) => {
                wItem.waivers.forEach((waiverE) => {
                  this.waivers.push(waiverE);
                });
              });
              if(this.waivers.length > 0) {
              this.listRegisters = this.waivers.map((el) => {
                  return el.id;
              });
              }
              const step3 = this.$refs.step3goStep4;
              step3.disabledLoadingStep = false;
              const step5 = this.$refs.stepWaiver5;
              step5.loadWaivers();
              this.nextStep(); 
            } else {
              this.submitWaiver();
            }
          }
        }).catch(() => {
          this.showSnackBar({ msg: this.$t('common.error_general')});
          const step3 = this.$refs.step3goStep4;
          step3.disabledLoadingStep = false;
        });
      },
      submitWaiver() {
        LocalStorageService.setItem('show_snack_bar', { msg: this.$t('eventWaiver.msg_success_created'), color: "success" });
        LocalStorageService.setItem('link_back_event_waiver_create', this.$route.name);
        const linkBack = this.nameComponentBack
        LocalStorageService.removeItem("link_back_event_waiver");
        if(linkBack == "RegisterEventLegacy") {
          LocalStorageService.removeItem("show_snack_bar");
          this.$router.push({
            name: "RegisterEventLegacy"
          });
          return;
        } else {
          this.$router.push({ name: 'EventWaiver' });
        }
      },
      loadEvent() {
        EventWaiverService.getEvent(this.$route.query.eventId).then(resp => {
          if(resp.data.success) {
            this.changeEventsList([resp.data.message]);
            this.$refs.step1goStep2.disabledLoadingStep1 = false;
            this.nextStep();
          }
        })
      },
      getAge(birthday){
            const birthdayDay = new Date(birthday);
            const nowDay = new Date();
            let age = nowDay.getFullYear() - birthdayDay.getFullYear();
            let differenceMonths = nowDay.getMonth() - birthdayDay.getMonth();
            if(differenceMonths < 0 || (differenceMonths == 0 && nowDay.getDate() < birthdayDay.getDate())) {
                age--;
            }
            return age;
      }
    }
}
</script>

<style>
.eventWaiverCreate {
    width: 100%;
}
.eventWaiverCreate .v-data-table-header,
.eventWaiverCreate .v-card__title {
  background: #ccc;
}
.mt16 {
  margin-top: 16px;
}
.btn{
  color:#fff !important;
}
.v-card__actions{
  display: inherit;
  text-align: right;
}
.v-snack__wrapper{
  position: absolute;
}
</style>